import React from 'react';

function AboutPage() {
  return (
    <div id="aboutContent" className="content-section">
      {/* Doornoc Header with Logo */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '20px',
        marginBottom: '30px',
        padding: '30px',
        backgroundColor: '#112030',
        borderRadius: '12px',
        color: 'white'
      }}>
        <img
          src="/doornoc-logo-white.png"
          alt="Doornoc Logo"
          style={{ height: '80px', width: 'auto' }}
        />
        <div>
          <h1 style={{ margin: 0, color: 'white', fontSize: '32px' }}>Doornoc</h1>
          <p style={{ margin: '5px 0 0 0', color: '#aaa', fontSize: '16px' }}>
            Political Campaign Technology Solutions
          </p>
        </div>
      </div>

      <h2>About Doornoc</h2>
      <p style={{ fontSize: '17px', lineHeight: '1.7' }}>
        <strong>Doornoc</strong> is a leading political technology company founded with a mission to democratize access to campaign tools and voter data. We believe that every candidate, regardless of budget size, deserves access to the same powerful tools that were once only available to well-funded campaigns.
      </p>
      <p style={{ fontSize: '17px', lineHeight: '1.7' }}>
        Our team combines decades of experience in political campaigns, data science, and software development to create solutions that are both powerful and easy to use. From local school board races to statewide campaigns, Doornoc provides the technology backbone that modern campaigns need to succeed.
      </p>

      {/* MailVotes Section */}
      <div style={{
        backgroundColor: '#e8f4f8',
        padding: '25px',
        borderRadius: '8px',
        marginTop: '30px',
        marginBottom: '30px',
        border: '1px solid #b8dadd'
      }}>
        <h2 style={{ color: '#112030', marginTop: 0 }}>About MailVotes</h2>
        <p style={{ fontSize: '16px', lineHeight: '1.7' }}>
          <strong>MailVotes</strong> is Doornoc's flagship voter data platform, designed specifically for creating highly targeted mailing lists for political campaigns. Our platform provides:
        </p>
        <ul style={{ fontSize: '15px', lineHeight: '2', paddingLeft: '20px' }}>
          <li><strong>Comprehensive Voter Database</strong> - Access millions of voter records across multiple states</li>
          <li><strong>Advanced Filtering</strong> - Filter by demographics, voting history, party affiliation, and geography</li>
          <li><strong>Query Wizard</strong> - Step-by-step guidance to build the perfect voter list</li>
          <li><strong>Instant Export</strong> - Download your lists in CSV format, ready for mail houses</li>
          <li><strong>Real-time Data</strong> - Regularly updated voter information for accuracy</li>
        </ul>
      </div>

      <h3>Our Mission</h3>
      <p style={{ fontSize: '17px', lineHeight: '1.7' }}>
        At Doornoc, we're dedicated to empowering political campaigns with the data and tools they need to connect with voters effectively. We believe in the power of grassroots organizing and data-driven decision making. Our platform combines cutting-edge technology with comprehensive voter data to help campaigns of all sizes maximize their outreach and impact.
      </p>

      <h3>The Doornoc Platform</h3>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px', marginTop: '20px' }}>
        <div style={{ padding: '20px', backgroundColor: '#e8f5e9', border: '1px solid #c8e6c9', borderRadius: '8px' }}>
          <h4 style={{ color: '#2e7d32', marginTop: 0 }}>MailVotes - Voter Mailing Lists</h4>
          <p style={{ color: '#333' }}>Create highly targeted mailing lists with our intuitive Query Wizard. Filter by state, county, city, political affiliation, voting history, and more. Export ready-to-use CSV files for your direct mail campaigns.</p>
        </div>
        <div style={{ padding: '20px', backgroundColor: '#e3f2fd', border: '1px solid #bbdefb', borderRadius: '8px' }}>
          <h4 style={{ color: '#1565c0', marginTop: 0 }}>Doornoc - Canvassing App</h4>
          <p style={{ color: '#333' }}>Our mobile-friendly canvassing platform helps you organize door-to-door operations. Create walking routes, track volunteer progress, record voter interactions, and sync data in real-time across your entire team.</p>
        </div>
        <div style={{ padding: '20px', backgroundColor: '#f3e5f5', border: '1px solid #e1bee7', borderRadius: '8px' }}>
          <h4 style={{ color: '#7b1fa2', marginTop: 0 }}>Campaign Analytics</h4>
          <p style={{ color: '#333' }}>Gain insights into your campaign's performance with real-time analytics. Track knock rates, voter sentiment, support levels, and team productivity all from one dashboard.</p>
        </div>
        <div style={{ padding: '20px', backgroundColor: '#fff3e0', border: '1px solid #ffe0b2', borderRadius: '8px' }}>
          <h4 style={{ color: '#e65100', marginTop: 0 }}>Team Management</h4>
          <p style={{ color: '#333' }}>Coordinate your campaign staff and volunteers efficiently. Assign routes, manage permissions, track hours, and communicate with your team through our integrated platform.</p>
        </div>
      </div>

      {/* States Coverage */}
      <div style={{
        backgroundColor: '#f8f9fa',
        padding: '25px',
        borderRadius: '8px',
        marginTop: '30px',
        marginBottom: '30px'
      }}>
        <h3 style={{ marginTop: 0 }}>Available States</h3>
        <p>We currently provide voter data for the following states:</p>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', marginTop: '15px' }}>
          {[
            { state: 'Florida', abbr: 'FL', voters: '14M+' },
            { state: 'North Carolina', abbr: 'NC', voters: '7M+' },
            { state: 'Pennsylvania', abbr: 'PA', voters: '8M+' },
            { state: 'Ohio', abbr: 'OH', voters: '8M+' },
            { state: 'Oklahoma', abbr: 'OK', voters: '2M+' },
            { state: 'Arkansas', abbr: 'AR', voters: '1.7M+' }
          ].map(item => (
            <div key={item.abbr} style={{
              backgroundColor: '#112030',
              color: 'white',
              padding: '12px 20px',
              borderRadius: '8px',
              textAlign: 'center',
              minWidth: '140px'
            }}>
              <div style={{ fontSize: '18px', fontWeight: 'bold' }}>{item.state}</div>
              <div style={{ fontSize: '12px', color: '#aaa' }}>{item.voters} voters</div>
            </div>
          ))}
        </div>
        <p style={{ fontSize: '14px', color: '#666', marginTop: '15px' }}>
          More states coming soon! Contact us if you need data for a state not listed.
        </p>
      </div>

      {/* Why Choose Us */}
      <h3>Why Choose Doornoc?</h3>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginTop: '20px' }}>
        <div style={{ padding: '20px', backgroundColor: '#fff', border: '1px solid #ddd', borderRadius: '8px' }}>
          <h4 style={{ color: '#112030', marginTop: 0 }}>Affordable Pricing</h4>
          <p style={{ fontSize: '14px', color: '#666' }}>We believe every campaign deserves access to quality data. Our pricing is designed to be accessible for campaigns of all sizes.</p>
        </div>
        <div style={{ padding: '20px', backgroundColor: '#fff', border: '1px solid #ddd', borderRadius: '8px' }}>
          <h4 style={{ color: '#112030', marginTop: 0 }}>Easy to Use</h4>
          <p style={{ fontSize: '14px', color: '#666' }}>No technical expertise required. Our intuitive interfaces guide you through every step of the process.</p>
        </div>
        <div style={{ padding: '20px', backgroundColor: '#fff', border: '1px solid #ddd', borderRadius: '8px' }}>
          <h4 style={{ color: '#112030', marginTop: 0 }}>Accurate Data</h4>
          <p style={{ fontSize: '14px', color: '#666' }}>We source our data directly from state voter files and update regularly to ensure accuracy.</p>
        </div>
        <div style={{ padding: '20px', backgroundColor: '#fff', border: '1px solid #ddd', borderRadius: '8px' }}>
          <h4 style={{ color: '#112030', marginTop: 0 }}>Dedicated Support</h4>
          <p style={{ fontSize: '14px', color: '#666' }}>Our team is here to help. Get assistance with your campaigns whenever you need it.</p>
        </div>
      </div>

      {/* Contact Section */}
      <div style={{
        backgroundColor: '#112030',
        color: 'white',
        padding: '30px',
        borderRadius: '8px',
        marginTop: '40px',
        textAlign: 'center'
      }}>
        <h3 style={{ color: 'white', marginTop: 0 }}>Ready to Get Started?</h3>
        <p style={{ fontSize: '16px', marginBottom: '20px', color: '#e0e0e0' }}>
          Contact us to learn more about how Doornoc can help your campaign succeed.
        </p>
        <p style={{ fontSize: '14px', color: '#ccc' }}>
          Email: <strong style={{ color: 'white' }}>contact@doornoc.com</strong>
        </p>
      </div>
    </div>
  );
}

export default AboutPage;
